import React, { Fragment, Component } from 'react';

import { Select } from 'components/input';
import { Modal } from 'components/modal';
import { I18n, translate } from 'components/translate';
import PropTypes from 'prop-types';

import './UsersListBulkActions.scss';

@translate()
class BulkActionModal extends Component {
  static propTypes = {
    t: PropTypes.func,
    label: PropTypes.object,
    membershipClass: PropTypes.object,
    dropdownIndicatorStyle: PropTypes.func,
    classesList: PropTypes.array,
    blockAll: PropTypes.array,
    changeUsersClass: PropTypes.func,
    setClass: PropTypes.func,
    onMenuOpen: PropTypes.func,
    toogleModal: PropTypes.func,
    massActionsType: PropTypes.object,
    bulkActionsPath: PropTypes.string,
    modal: PropTypes.object,
    resendAccess: PropTypes.func,
    exportCSV: PropTypes.func
  };

  state = {
    runningAction: false
  };

  buildBodyMsg = (action, to) => {
    const { t, bulkActionsPath } = this.props;

    return t(`${bulkActionsPath}.confirmation_message`, {
      data: { action, to }
    });
  };

  bodyChangeClasseModal() {
    const {
      dropdownIndicatorStyle,
      membershipClass,
      classesList,
      setClass,
      onMenuOpen
    } = this.props;

    return (
      <Fragment>
        <I18n label="class_manager.modal.transfer_students_body" />
        <Select
          name="class"
          className="class__select users__list__bulk__actions__class-modal__select"
          placeholder="users_import.manually.class.placeholder"
          components={{ IndicatorSeparator: () => null }}
          customStyles={{ dropdownIndicator: dropdownIndicatorStyle() }}
          onMenuOpen={onMenuOpen}
          value={membershipClass}
          options={classesList}
          onChange={setClass}
          isClearable={false}
        />
      </Fragment>
    );
  }

  get actions() {
    const {
      t,
      label,
      membershipClass,
      blockAll,
      changeUsersClass,
      resendAccess,
      exportCSV
    } = this.props;

    return {
      block: {
        onClick: () => blockAll(true),
        action: t(label.block),
        bodyMsg: this.buildBodyMsg(t(label.block), t('general.the_male_plural'))
      },
      unblock: {
        onClick: () => blockAll(false),
        action: t(label.unblock),
        bodyMsg: this.buildBodyMsg(
          t(label.unblock),
          t('general.the_male_plural')
        )
      },
      class: {
        onClick: changeUsersClass,
        okDisabled: !membershipClass,
        action: t('class_manager.modal.transfer_students_title'),
        bodyMsg: this.bodyChangeClasseModal()
      },
      resendAccess: {
        onClick: resendAccess,
        action: t(label.resendAccess),
        bodyMsg: this.buildBodyMsg(
          t(label.resendAccess),
          t('general.to_plural')
        )
      },
      exportCSV: {
        onClick: exportCSV,
        action: t(label.exportCSV),
        bodyMsg: this.buildBodyMsg(
          t(label.exportCSV),
          t('general.the_male_plural')
        )
      }
    };
  }

  handleOnClick = (onClick) => {
    const { runningAction } = this.state;

    this.setState({ runningAction: true });

    !runningAction && onClick && onClick();
  };

  render() {
    const { runningAction } = this.state;
    const { toogleModal, massActionsType, modal } = this.props;
    const {
      action: title,
      bodyMsg,
      okDisabled,
      onClick
    } = this.actions[massActionsType];

    return (
      <Modal onClose={() => toogleModal(modal.close)}>
        <Modal.Header>
          <h5 className="modal-header-warning">
            <I18n label="general.warn_title" />
          </h5>
          <h3 className="modal-title">{title}</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="title__label users__list__bulk__actions__class-modal">
            <div>{bodyMsg}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="hot-button hot-button--primary hot-button--lg"
            disabled={okDisabled || runningAction}
            onClick={this.handleOnClick.bind(this, onClick)}
          >
            <I18n label="general.ok" />
          </button>
          <button
            className="hot-button hot-button--lg"
            onClick={() => toogleModal(modal.close)}
          >
            <I18n label="general.cancel" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BulkActionModal;
